import { render, staticRenderFns } from "./IngredientItemStepEdit.vue?vue&type=template&id=5160d40b&scoped=true&"
import script from "./IngredientItemStepEdit.vue?vue&type=script&lang=js&"
export * from "./IngredientItemStepEdit.vue?vue&type=script&lang=js&"
import style0 from "./IngredientItemStepEdit.vue?vue&type=style&index=0&id=5160d40b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5160d40b",
  null
  
)

export default component.exports